export default __webpack_public_path__ + "assets/models/c42397058ca8ba1c0d784dbd20706377.glb";